import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-communication-model',
  templateUrl: './communication-model.component.html',
  styleUrls: ['./communication-model.component.scss']
})
export class CommunicationModelComponent {

  @Output() close:EventEmitter<any> = new EventEmitter();
  @Input() communicationData: any;

  constructor(
    private modalService: NgbModal,
    
    
  ) { }

  btnLoading = false;
  selectedOption: string | null = null;

  selectOption(option: string) {
    this.selectedOption = option;
  }

  pickAction(
    option: 'email' | 'call' | 'whatsapp',
    content1: unknown,
    content2: unknown,
    content3: unknown
  ): void {
    this.selectOption(option);
    this.close.emit();
    setTimeout(() => this.onSubmit(content1, content2, content3), 0);
  }

  onSubmit(content1: any, content2: any, content3: any) {
    if (this.selectedOption === 'email') {
      this.btnLoading = false;
      this.modalService.open(content1, {
        size: 'lg',
        scrollable: true,
        centered: true,
        backdrop: 'static',
        keyboard: false,
      });
    } else if (this.selectedOption === 'call') {
      this.btnLoading = false;
      this.modalService.open(content2, {
        size: 'md',
        scrollable: true,
        centered: true,
        backdrop: 'static',
        keyboard: false,
      });
    } else if (this.selectedOption === 'whatsapp') {
      this.btnLoading = false;
      this.modalService.open(content3, {
        size: 'lg',
        scrollable: true,
        centered: true,
        backdrop: 'static',
        keyboard: false,
      });
    }
  }


  closeModal() {
    this.close.emit();
  }

}
